// extracted by mini-css-extract-plugin
export var copyableItem = "_m-0";
export var underlined = "_m-1";